import React from "react";
import VerifyEmailRequiredModal from "./dashboard/VerifyEmailRequiredModal";

/**
 * GlobalVerifyEmailListener — app-level listener for the 412
 * "email_verification_required" responses dispatched by api.js. Lives
 * at the App root (not inside Dashboard) because the gate also fires on
 * /pricing (checkout), /dashboard (wallet add), and any future surface
 * — keeping the modal globally mounted means every page gets the same
 * polished UX without per-page wiring.
 *
 * The `__cryptpe_verify_listener__` flag suppresses the duplicate toast
 * fallback in api.js while this rich modal handles the event.
 */
export default function GlobalVerifyEmailListener() {
  const [open, setOpen] = React.useState(false);
  const [payload, setPayload] = React.useState({
    action: "this action",
    email: "",
    message: "",
  });

  React.useEffect(() => {
    window.__cryptpe_verify_listener__ = true;
    const onVerify = (e) => {
      setPayload({
        action: e.detail?.action || "this action",
        email: e.detail?.email || "",
        message: e.detail?.message || "",
      });
      setOpen(true);
    };
    window.addEventListener("cryptpe:verify-email", onVerify);
    return () => {
      window.removeEventListener("cryptpe:verify-email", onVerify);
      delete window.__cryptpe_verify_listener__;
    };
  }, []);

  return (
    <VerifyEmailRequiredModal
      open={open}
      payload={payload}
      onClose={() => setOpen(false)}
    />
  );
}
